export const environment = {
  production: true,
  timezone: 'GMT',
  validQualifiers: ['DJCTQ'],
  langFilters: ['pt','pt-br','en'],
  defaultLang: 'pt',
  apiUrl: 'https://o43ezk2awf.execute-api.us-west-2.amazonaws.com/api',
};